var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Add@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Add",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "+",
    transform: "translate(14.5, 14.5003)",
    fill: "#2C2C2C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,6.49968719 C13,6.91531181 12.6656246,7.24968719 12.25,7.24968719 L7.25,7.24968719 L7.25,12.2496872 C7.25,12.6637497 6.9140625,13 6.5,13 C6.0859375,13 5.75,12.6653118 5.75,12.2496872 L5.75,7.24968719 L0.75,7.24968719 C0.3359375,7.24968719 0,6.9140625 0,6.5 C0,6.08718729 0.3359375,5.74968719 0.75,5.74968719 L5.75,5.74968719 L5.75,0.749687195 C5.75,0.335624695 6.0859375,0 6.5,0 C6.9140625,0 7.25,0.335624695 7.25,0.749687195 L7.25,5.74968719 L12.25,5.74968719 C12.6656246,5.74968719 13,6.08718729 13,6.49968719 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.9b695b7319216c228239d7b1fde1659a.svg";
export { ForwardRef as ReactComponent };